<template>
  <div>
    <section id="content">
      <v-container grid-list-md class="pa-0" fluid>
        <v-layout row wrap>
          <v-flex md4 xs6>
            <v-select
              :items="logTypes"
              item-text="name"
              item-value="id"
              v-on:input="loadLog();"
              v-model="logFilter"
              label="Selecteer logtype"
              :item-color="companyPrimaryColor"
              :color="companyPrimaryColor"
              :background-color="$vuetify.theme.themes[theme].menu"       
              outlined
              dense
              >
            </v-select>
          </v-flex>
          <v-flex md4 xs6>
          </v-flex>
          <v-flex md4 xs6>
            <v-row >
              <v-btn class="px-4" small fab darken color="secondary" v-if="selected.length > 0" @click="deleteLog()">
                <v-icon dark small color="#fff" >delete</v-icon>
              </v-btn>
              <v-text-field
                class="px-2"
                v-model="search"
                name="searchfield"
                :color="companyPrimaryColor"
                placeholder="Zoeken"
                outlined
                hide-details     
                :background-color="$vuetify.theme.themes[theme].menu"                                                    
                prepend-inner-icon="search"
                autocomplete="disabled"
                clearable
                dense
                single-line>
              </v-text-field>
            </v-row>
          </v-flex>
        </v-layout>
      </v-container>

      <div v-if="loading == true && deleting == false">
        <div class="loading-dots">
          <div class="loading-dots-loader"></div>
          <p class="loading-dots-text"></p>
        </div>
      </div>

      <div v-if="deleting == true">
        <div class="loading-dots">
          <div class="loading-dots-loader"></div>
          <p class="loading-dots-text"> {{ deleteCounter }} van {{ selected.length }} verwijderd. </p>
        </div>
      </div>

      <v-card outlined v-if="loading == false && deleting == false" >
        <div v-if="logFilter == 'User Action'">
          <v-data-table
            :headers="headers"
            :items="userLog"
            :itemsPerPage.sync="logPages"
            v-model="selected"
            :search="search"
            single-expand
            color="primary"
            show-expand
            show-select
            hide-default-footer
            no-data-text="Geen logs aanwezig."  
            :no-results-text="`Geen resultaten gevonden voor: ${search}`"
            class="log-table">
            <template v-slot:item="{item, isSelected, select, isExpanded, expand}">
              <tr>
                <td class="select-row">
                  <v-icon @click="select(true)" v-if="!isSelected">check_box_outline_blank</v-icon>
                  <v-icon @click="select(false)" v-if="isSelected" color="primary">check_box</v-icon>
                </td>
                <td>{{ item.time.seconds | moment("D MMM YYYY - H:mm") }}u</td>
                <td>
                  <v-icon v-if="item.logType == 'loginerror'" color="red">warning</v-icon>
                  <v-icon v-if="item.logType == 'error'" color="red">warning</v-icon>
                  <v-icon v-if="item.logType == 'info'" color="grey lighten-1">info</v-icon>
                </td>
                <td>
                  <span v-if="item.logType == 'loginerror'">
                    <span v-for="user in users" :key="user.email">
                      <span v-if="item.loginEmail && (user.email == item.loginEmail)">
                        <span v-for="company in companies" :key="company.id">
                          <span v-if="company.id == user.company">{{ company.name }}</span>
                        </span>
                      </span>
                    </span>
                  </span>
                  <span v-else>
                    <span v-for="company in companies" :key="company.id">
                      <span v-if="company.id == item.company">{{ company.name }}</span>
                    </span>
                  </span>
                </td>
                <td>
                  <span v-if="item.logType == 'loginerror'">
                    <span v-for="user in users" :key="user.email">
                      <span v-if="item.loginEmail && (user.email == item.loginEmail)">{{ user.firstName }} {{ user.lastName }} </span>
                    </span>
                  </span>
                  <span v-else>{{ item.user }}</span>
                </td>
                <td>
                  <span v-if="item.logType == 'loginerror'">
                    <span v-for="user in users" :key="user.email">
                      <span v-if="item.loginEmail && (user.email == item.loginEmail)">
                        <span v-for="role in userRoles" :key="role.id">
                          <span v-if="role.id == user.userRole">{{ role.name }}</span>
                        </span>
                      </span>
                    </span>
                  </span>
                  <span v-else>
                    <span v-for="role in userRoles" :key="role.id">
                    <span v-if="role.id == item.userType">{{ role.name }}</span>
                  </span>
                  </span>
                </td>
                <td>{{ item.actionType }}</td>
                <td>{{ item.action }}</td>
                <td>
                  <v-btn icon @click="expand(true)" v-if="!isExpanded"><v-icon :color="$vuetify.theme.themes[theme].text" dark>expand_more</v-icon></v-btn>
                  <v-btn icon @click="expand(false)" v-if="isExpanded"><v-icon :color="$vuetify.theme.themes[theme].text" dark>expand_less</v-icon></v-btn>
                </td>
              </tr>
            </template>
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length" style="padding: 0!important;">
                <v-card flat style="border-bottom: 1px solid#e8e9ee!important; border-radius: 0!important" color="background">
                  <v-card-text style="font-size: 12px!important; padding: 10px;" >
                    <p class="ma-0"><strong>Software: </strong>{{item.software}}</p>
                    <p class="ma-0"><strong>Browser: </strong>{{item.browser}}</p>
                    <span v-if="item.extra">
                      <br>
                      <div v-html="item.extra "></div>
                    </span>
                  </v-card-text>
                </v-card>
              </td>
            </template>
          </v-data-table>
          <div v-if="userLog.length >= 50" class="text-xs-center" style="padding: 20px;">
            <v-row align="center">
              <v-col class="text-center" cols="12">
                <v-btn v-if="extraLoading == false && userLog.length < 200" color="primary" dark @click.native="loadMoreUserLogs()">Meer logs laden</v-btn>
              </v-col>
            </v-row>
            <div v-if="extraLoading == true" class="extra-loading-dots"></div>
          </div>
        </div>

        <div v-if="logFilter == 'Server Action'">
          <v-data-table
            :headers="headersServer"
            :items="serverLog"
            :itemsPerPage.sync="logPages"
            v-model="selected"
            :search="search"
            single-expand
            show-expand
            show-select
            hide-default-footer
            no-data-text="Geen logs aanwezig."   
            :no-results-text="`Geen resultaten gevonden voor: ${search}`"
            class="log-table">
            <template v-slot:item="{item, isSelected, select, isExpanded, expand}">
              <tr>
                <td>
                  <v-icon @click="select(true)" v-if="!isSelected">check_box_outline_blank</v-icon>
                  <v-icon @click="select(false)" v-if="isSelected" >check_box</v-icon>
                </td>
                <td>{{ item.time.seconds | moment("DD MMM YYYY - H:mm") }}u</td>
                <td>
                  <v-icon v-if="item.logType == 'error'" color="red">warning</v-icon>
                  <v-icon v-if="item.logType == 'info'" color="grey lighten-1">info</v-icon>
                </td>
                <td>{{ item.actionType }}</td>
                <td>{{ item.companyName }}</td>
                <td>{{ item.action }}</td>
                <td>
                  <span v-if="item.surveyDetails">
                    {{ item.surveyDetails.clients.length }}
                  </span>
                  <span v-if="item.number">
                    {{ item.number }}
                  </span>
                </td>
                <td>
                  <v-btn icon @click="expand(true)" v-if="!isExpanded"><v-icon :color="$vuetify.theme.themes[theme].text" dark>expand_more</v-icon></v-btn>
                  <v-btn icon @click="expand(false)" v-if="isExpanded"><v-icon :color="$vuetify.theme.themes[theme].text" dark>expand_less</v-icon></v-btn>
                </td>
              </tr>
            </template>
            <template v-slot:expanded-item="{ headers, item }">
              <td :colspan="headers.length" style="padding: 0;">
                <v-card flat style="border-bottom: 1px;" :style="{backgroundColor: $vuetify.theme.themes[theme].menu, borderColor: $vuetify.theme.themes[theme].menuborder}">
                  <v-card-text v-if="item.surveyDetails" style="font-size: 12px!important; padding: 10px;">
                    <span v-for="(client, index) in item.surveyDetails.clients" :key="client">
                      <p style="margin-bottom: 0;">{{ index +1 }}. {{ client }}</p>
                    </span>
                  </v-card-text>
                  <v-card-text v-if="item.details">
                    <div v-html="item.details"></div>
                  </v-card-text>
                </v-card>
              </td>
            </template>
          </v-data-table>
          <div v-if="serverLog.length >= 50" class="text-xs-center" style="padding: 20px;">
            <v-row align="center">
              <v-col class="text-center" cols="12">
                <v-btn v-if="extraLoading == false && serverLog.length < 200" color="primary" dark @click.native="loadMoreServerLogs()">Meer logs laden</v-btn>
              </v-col>
            </v-row>
            <div v-if="extraLoading == true" class="extra-loading-dots"></div>
          </div>       
        </div>
      </v-card>
    </section>
  </div>
</template>


<script>

import db from "../firebase/init";
// import moment from "vue-moment";

export default {
  name: "log",
  data: () => ({
    search: "",
    deleteCounter: 0,
    loading: true,
    extraLoading: false,
    deleting: false,
    logPages: -1,
    logTypes: [
      {
        name: "User Actions",
        id: "User Action"
      },
      {
        name: "Server Actions",
        id: "Server Action"
      }
    ],
    logFilter: "User Action",
    removeBookings: "",
    selected: [],
    userLog: [],
    serverLog: [],
    serverLogContinueAt: {},
    userLogContinueAt: {},
    headers: [
      {
        text: "Tijd",
        align: "left",
        value: "time.seconds",
        width: "130px"
      },
      {
        text: "",
        align: "left",
        value: "logType"
      },
      {
        text: "Company",
        align: "left",
        value: "company"
      },
      {
        text: "Gebruiker",
        align: "left",
        value: "user"
      },
      {
        text: "Type gebruiker",
        align: "left",
        value: "user-type",
        width: "140px"
      },
      {
        text: "Action Type",
        align: "left",
        value: "action-type",
        width: "140px"
      },
      {
        text: "Action",
        align: "left",
        value: "action"
      },
      {
        text: "",
        value: "data-table-expand",
        align: "right",
        width: "70px",
        sortable: false
      }
    ],
    headersServer: [
      {
        text: "Tijd",
        align: "left",
        value: "time.seconds"
      },
      {
        text: "Action Type",
        align: "left",
        value: "actionType"
      },
      {
        text: "Company",
        align: "left",
        value: "company"
      },
      {
        text: "Action",
        align: "left",
        value: "action"
      },
      {
        text: "Clients",
        align: "left",
        value: "clients"
      },
      {
        text: "",
        align: "left",
        value: "numbers"
      },
      {
        text: "",
        value: "data-table-expand",
        align: "right",
        width: "70px",
        sortable: false
      }

    ],
    userRoles: [
      {
        name: "Admin",
        id: "admin"
      },
      {
        name: "Superadmin",
        id: "superadmin"
      },
      {
        name: "Medewerker",
        id: "employee"
      },
      {
        name: "Manager",
        id: "manager"
      }
    ],
    companies: [],
    users: [],
    pagination: {
      rowsPerPage: "200",
      sortBy: "time.seconds",
      descending: true
    }
  }),

  created() {
    this.loadUsers();
    this.loadCompanies();
    this.loadLog();
  },

  methods: {
    loadLog() {
      this.selected = [];
      this.search = "";

      if (this.logFilter == "User Action") {
        if (this.userLog.length < 50) {
          this.loading = true;
          db.collection("log")
            .where("actionType", "==", "User Action")
            .orderBy("time", "desc")
            .limit(50)
            .get()
            .then(snap => {
              snap.forEach(doc => {
                let logCollection = doc.data();
                logCollection.id = doc.id;
                this.userLog.push(logCollection);
              });
              this.userLogContinueAt = snap.docs[snap.docs.length - 1];
            })
            .then(() => {
              this.loading = false;
            });
        } else {
          console.log("Laden Userlog niet nodig");
        }
      } else if (this.logFilter == "Server Action") {
        if (this.serverLog.length < 50) {
          this.loading = true;
          db.collection("log")
            .where("actionType", "==", "Server Action")
            .orderBy("time", "desc")
            .limit(50)
            .get()
            .then(snap => {
              snap.forEach(doc => {
                let logCollection = doc.data();
                logCollection.id = doc.id;
                this.serverLog.push(logCollection);
              });
              this.serverLogContinueAt = snap.docs[snap.docs.length - 1];
            })
            .then(() => {
              this.loading = false;
            });
        } else {
          console.log("Laden Serverlog niet nodig");
        }
      }
    },

    loadLogAfterRemoval() {
      this.search = "";

      if (this.logFilter == "User Action") {
        this.loading = true;
        db.collection("log")
          .where("actionType", "==", "User Action")
          .orderBy("time", "desc")
          .limit(50)
          .get()
          .then(snap => {
            this.userLog = [];
            snap.forEach(doc => {
              let logCollection = doc.data();
              logCollection.id = doc.id;
              this.userLog.push(logCollection);
            });
            this.userLogContinueAt = snap.docs[snap.docs.length - 1];
          })
          .then(() => {
            this.loading = false;
          });
      } else if (this.logFilter == "Server Action") {
        this.loading = true;
        db.collection("log")
          .where("actionType", "==", "Server Action")
          .orderBy("time", "desc")
          .limit(50)
          .get()
          .then(snap => {
            this.serverLog = [];
            snap.forEach(doc => {
              let logCollection = doc.data();
              logCollection.id = doc.id;
              this.serverLog.push(logCollection);
            });
            this.serverLogContinueAt = snap.docs[snap.docs.length - 1];
          })
          .then(() => {
            this.loading = false;
          });
      }
    },

    loadMoreServerLogs() {
      this.extraLoading = true;
      db.collection("log")
        .where("actionType", "==", "Server Action")
        .orderBy("time", "desc")
        .startAfter(this.serverLogContinueAt)
        .limit(50)
        .get()
        .then(snap => {
          snap.forEach(doc => {
            let logCollection = doc.data();
            logCollection.id = doc.id;
            this.serverLog.push(logCollection);
          });
          this.serverLogContinueAt = snap.docs[snap.docs.length - 1];
        })
        .then(() => {
          this.extraLoading = false;
        })
        .catch(error => {
          console.error(error);
        });
    },

    loadMoreUserLogs() {
      this.extraLoading = true;
      db.collection("log")
        .where("actionType", "==", "User Action")
        .orderBy("time", "desc")
        .startAfter(this.userLogContinueAt)
        .limit(50)
        .get()
        .then(snap => {
          snap.forEach(doc => {
            let logCollection = doc.data();
            logCollection.id = doc.id;
            this.userLog.push(logCollection);
          });
          this.userLogContinueAt = snap.docs[snap.docs.length - 1];
        })
        .then(() => {
          this.extraLoading = false;
        })
        .catch(error => {
          console.error(error);
        });
    },

    deleteLog() {
      this.deleting = true;
      new Promise((resolve) => {
        let counter = 0;
        this.selected.forEach(element => {
          db.collection("log")
            .doc(element.id)
            .delete()
            .then(() => {
              counter++;
              this.deleteCounter++;
              if (counter == this.selected.length) {
                resolve();
              }
            })
            .catch(error => {
              console.error("Error removing log: ", error);
              counter++;
              this.deleteCounter++;
              if (counter == this.selected.length) {
                resolve();
              }
            });
        });
      }).then(() => {
        this.selected = [];
        this.deleteCounter = 0;
        this.loadLogAfterRemoval();
        this.deleting = false;
      });
    },

    loadCompanies() {
      db.collection("companies")
        .get()
        .then(snap => {
          this.companies = [];
          snap.forEach(doc => {
            let compCollection = doc.data();
            compCollection.id = doc.id;
            this.companies.push(compCollection);
          });
        });
    },

    loadUsers() {
      db.collection("users")
        .get()
        .then(snap => {
          this.users = [];
          snap.forEach(doc => {
            let user = doc.data();
            this.users.push(user);
          });
        });
    }
  },

  computed: {
    companyPrimaryColor() {
      return this.$store.state.companyPrimaryColor;
    },
    companySecondaryColor() {
      return this.$store.state.companySecondaryColor;
    },
    theme(){
      return (this.$vuetify.theme.dark) ? 'dark' : 'light'
    },
  }
};
</script>
